import {
  GET_LEGAL_DOCUMENTS,
  GET_LEGAL_DOCUMENTS_SUCCESS,
  GET_LEGAL_DOCUMENTS_FAILURE,
  GET_LEGAL_DOCUMENT_BY_ID,
  GET_LEGAL_DOCUMENT_BY_ID_SUCCESS,
  GET_LEGAL_DOCUMENT_BY_ID_FAILURE,
  CREATE_LEGAL_DOCUMENT,
  CREATE_LEGAL_DOCUMENT_SUCCESS,
  CREATE_LEGAL_DOCUMENT_FAILURE,
  UPDATE_LEGAL_DOCUMENT_BY_ID,
  UPDATE_LEGAL_DOCUMENT_BY_ID_SUCCESS,
  UPDATE_LEGAL_DOCUMENT_BY_ID_FAILURE,
  DELETE_LEGAL_DOCUMENT_BY_ID,
  DELETE_LEGAL_DOCUMENT_BY_ID_SUCCESS,
  DELETE_LEGAL_DOCUMENT_BY_ID_FAILURE,
} from './const'
import createMiddleware from 'Reducers/createMiddleware'
import {
  getLegalDocumentsListQuery,
  getLegalDocumentByIdQuery,
  createLegalDocumentMutation,
  updateLegalDocumentByIdMutation,
  deleteLegalDocumentByIdMutation,
} from '../../Module/graphQL/LegalDocument/legalDocumentGraphQL'

export const getLegalDocumentsMiddleware = createMiddleware({
  actions: [
    GET_LEGAL_DOCUMENTS,
    GET_LEGAL_DOCUMENTS_SUCCESS,
    GET_LEGAL_DOCUMENTS_FAILURE,
  ],
  fetchMethod: getLegalDocumentsListQuery,
  isOptimistic: false,
})

export const getLegalDocumentByIdMiddleware = createMiddleware({
  actions: [
    GET_LEGAL_DOCUMENT_BY_ID,
    GET_LEGAL_DOCUMENT_BY_ID_SUCCESS,
    GET_LEGAL_DOCUMENT_BY_ID_FAILURE,
  ],
  fetchMethod: getLegalDocumentByIdQuery,
  isOptimistic: false,
})

export const createLegalDocumentMiddleware = createMiddleware({
  actions: [
    CREATE_LEGAL_DOCUMENT,
    CREATE_LEGAL_DOCUMENT_SUCCESS,
    CREATE_LEGAL_DOCUMENT_FAILURE,
  ],
  fetchMethod: createLegalDocumentMutation,
  isOptimistic: false,
})
export const updateLegalDocumentByIdMiddleware = createMiddleware({
  actions: [
    UPDATE_LEGAL_DOCUMENT_BY_ID,
    UPDATE_LEGAL_DOCUMENT_BY_ID_SUCCESS,
    UPDATE_LEGAL_DOCUMENT_BY_ID_FAILURE,
  ],
  fetchMethod: updateLegalDocumentByIdMutation,
  isOptimistic: false,
})
export const deleteLegalDocumentByIdMiddleware = createMiddleware({
  actions: [
    DELETE_LEGAL_DOCUMENT_BY_ID,
    DELETE_LEGAL_DOCUMENT_BY_ID_SUCCESS,
    DELETE_LEGAL_DOCUMENT_BY_ID_FAILURE,
  ],
  fetchMethod: deleteLegalDocumentByIdMutation,
  isOptimistic: false,
})



// WEBPACK FOOTER //
// ./src/Reducers/LegalDocument/middleware.js